import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--brand-dark)',
      color: 'white',
      padding: '48px 24px 24px',
      marginTop: '64px'
    }}>
      <div className="container" style={{
        maxWidth: '1440px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '32px',
          marginBottom: '32px'
        }}>
          {/* Coluna 1 */}
          <div>
            <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>Galla Personal Systems</h3>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: 'rgba(255,255,255,0.8)' }}>
              Transforme seu corpo com nossos programas de treinamento profissionais. Resultados garantidos em 4 semanas.
            </p>
          </div>

          {/* Coluna 2 */}
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Links Rápidos</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: '14px' }}>Início</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/produtos" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: '14px' }}>Produtos</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/carrinho" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none', fontSize: '14px' }}>Carrinho</Link>
              </li>
            </ul>
          </div>

          {/* Coluna 3 */}
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Contato</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} />
                <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>gallo.personal@gmail.com</span>
              </li>
              <li style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} />
                <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>(71) 99289-3333</span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={16} />
                <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>Salvador, Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.2)',
          paddingTop: '24px',
          textAlign: 'center'
        }}>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
            © 2025 Galla Personal Systems. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;